import { __assign, __read } from "tslib";
import { id } from '@slardar/sdk-template';
import { FetchMonitor } from '../../monitors/fetch';
import { applyMonitor } from '../../utils';
import { getCbHook } from './ajax';
import { getPluginConfig } from './utils';
export var FETCH_MONITOR_PLUGIN_NAME = 'fetch';
var defaultConfig = {
    autoWrap: true,
    hookCbAtReq: id,
    ignoreUrls: [],
    collectBodyOnError: false,
};
export function FetchMonitorPlugin(client) {
    client.on('init', function () {
        var config = getPluginConfig(client, FETCH_MONITOR_PLUGIN_NAME, defaultConfig);
        if (!config) {
            return;
        }
        var tearDownFlag = false;
        var tearDown = function () {
            tearDownFlag = true;
        };
        var cb = function (ev) { return !tearDownFlag && client.report(ev); };
        var _a = __read(applyMonitor(FetchMonitor, __assign(__assign({}, config), { hookCbAtReq: getCbHook(client) }), cb), 1), wrapFetch = _a[0];
        client.on('beforeDestroy', tearDown);
        client.provide('wrapFetch', wrapFetch);
    });
}
//# sourceMappingURL=fetch.js.map